export default "__VITE_ASSET__CVj_neGr__"